
import Vue from 'vue'
import axios from 'axios'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class ProfileImage extends Vue {
  @Prop({ type: String, default: null })
  private readonly path!: string

  @Prop({ type: Boolean, default: false })
  private readonly noPrepend!: boolean

  @Prop({ type: String, default: null })
  private readonly uploadPath!: string

  @Prop({ type: String, default: '200px' })
  private readonly height!: string

  @Prop({ type: String, default: null })
  private readonly displayHeight!: string

  @Prop({ type: String, default: '200px' })
  private readonly width!: string

  @Prop({ type: String, default: null })
  private readonly title!: string

  @Prop({ type: String, default: null })
  private readonly emptyText!: string
  
  @Prop({ type: Boolean, default: true })
  private readonly clickable!: boolean

  loading = false

  error = false

  get imagePath() {
    return this.noPrepend ? this.path : `${this.$store.state.auth.mediaUrl}${this.path}`
  }
  
  pickFile() {
    const input = this.$refs.image as HTMLInputElement
    input.click()
  }

  async onFilePicked(e: Event) {
    const files = (e.target as HTMLInputElement).files || new FileList()

    if (files.length) {
      const file = files[0]
      this.loading = true
      const path = await this.uploadFile(this.uploadPath, file)
      this.$emit('image-upload', path)
      this.loading = false
    }
  }

  async uploadFile(path: string, file: File) {
    const formData = new FormData()
    formData.append('file', file)
    try {
      const response = await axios.post<{ path: string }>(path, formData, { headers: { 'content-type': 'multipart/form-data' } })
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(response.data.path)
        }, 3000)
      })
    } catch (error) {
      this.$store.dispatch('error', 'An error occurred uploading the image')
    }
  }
}
